module.exports = __webpack_public_path__ + "img/main-menu-cow888-14.3f877ffb.png";